import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { UserModule } from './user/user.module';
import { RoleModule } from './role/role.module';
import { DenemeModule } from './deneme/deneme.module';
import { RoleManagementModule } from './role-management/role-management.module';
import { CompanyModule } from './company/company.module';
import { CurrencyModule } from './currency/currency.module';
import { ProductModule } from './product/product.module';
import { OfferModule } from './Offer/offer.module';
import { KindModule } from './kind/kind.module';
import { PageModule } from './page/page.module';
import { CategoryModule } from './category/category.module';
import { OrderModule } from './order/order.module';
import { VaultModule } from './vault/vault.module';
import { WarehosuseModule } from './warehouse/warehouse.module';
import { TaxModule } from './tax/tax.module';
import { UnitTypeModule } from './unit-type/unit-type.module';
import { ProjectModule } from './project/project.module';
import { PdfModule } from './pdf/pdf.module';
import { RequestTaskModule } from './request-task/request-task.module';
import { PersonModule } from './person/person.module';
import { BuyingModule } from './buying/buying.module';
import { SalesModule } from './sales/sales.module';
import { TransactionDescriptionModule } from './transaction-description/transaction-description.module';
import { ExpenseModule } from './expense/expense.module';
import { ExpenseTransactionModule } from './expense-transaction/expense-transaction.module';
import { BrandModule } from './brand/brand.module';
import { BrandModelModule } from './brand-model/brand-model.module';
import { MainExpenseModule } from './main-expense/main-expense.module';
import { DeviceModule } from './device/device.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { FixturesModule } from './fixtures/fixtures.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserModule,
    RoleModule,
    CoreCommonModule,
    ContentHeaderModule,
    DenemeModule,
    RoleManagementModule,
    CompanyModule,
    CurrencyModule,
    ProductModule,
    OfferModule,
    KindModule,
    PageModule,
    CategoryModule,
    OrderModule,
    VaultModule,
    WarehosuseModule,
    TaxModule,
    UnitTypeModule,
    ProjectModule,
    PdfModule,
    RequestTaskModule,
    PersonModule,
    BuyingModule,
    SalesModule,
    TransactionDescriptionModule,
    ExpenseModule,
    ExpenseTransactionModule,
    BrandModule,
    BrandModelModule,
    MainExpenseModule,
    DeviceModule,
    //DashboardModule,
    FixturesModule
  ]
})
export class AdminModule { }